// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2_fSV","left":"InfoRow_left__2ftYX"};